























// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import apiUser from '@/api/user'
import { toSubArray } from '@/utils/groupBy'
import { directPayloadQuery } from '@/utils/api' 
import { AloSejour, getDefaultAloSejour } from '@/models/alo/AloSejour'
import cloneDeep from 'clone-deep'
import * as rules from '@/utils/validationRules'
import { AloCommande, getDefaultAloCommande } from '@/models/alo/AloCommande'
import { ItemPanier } from '@/models/alo/ItemPanier'
import { TemplateMail } from '@/enum/TemplateMail'
import { StatusCommande } from '@/enum/StatusCommande'
import CartDetail from '@/components/panier/CartDetail.vue'
import { getDefaultAloUser } from '@/models/alo/AloUser'
import { AloPanier } from '@/models/alo/AloPanier'
import { VuetifyConfirmObject } from 'vuetify-confirm'
import CarteRoomService from '@/components/carte/CarteRoomService.vue'
import { AloArbo } from '@/models/alo/AloArbo'


@Component({
  name: 'DetailHistory', 
  props: {
    commandeId:Number    
  },
  components: {CartDetail,CarteRoomService},
})

export default class DetailHistory extends Vue {
  commandeId!: number  
  private loading = false

  private original:AloCommande = getDefaultAloCommande()
  private commande:AloCommande = getDefaultAloCommande()  

  

  loadCommande() {    
    this.loading = true    
    if(this.commandeId != -1){
      this.$store.myActions.ADM_COMMANDE_DETAIL_REQUEST(this.commandeId).then((item:AloCommande)=>{
        this.original = {...getDefaultAloCommande(),...item}    
        this.commande = {...cloneDeep(this.original),panier:new AloPanier(JSON.parse(this.original.panJson))}
      })
      .finally(() => {      
        this.loading = false        
      })    
    }
    else{
      this.original = getDefaultAloCommande()
      this.commande =  getDefaultAloCommande()
    }
  }

  get sejour()  {
    //@ts-ignore 
    return this.commande.sejour?{...this.commande.sejour,user:{libelle:this.commande.libelle}} as AloSejour:getDefaultAloSejour()
  }

  private get arbosDic(){
    return this.$store.myGetters.arbosDic
  }

  get showValidate(){
    return this.commande.panStatus == StatusCommande.EnAttenteValidation
  }

  private get panStatusDic(){
    return this.$store.myGetters.panStatusDic
  } 

  
  created(){    
    this.$store.myActions.ADM_PAN_STATUS_ENSURE()  
    this.loadCommande()
  }  

 
  saveCommande(autoClose = true) {      
    this.$store.myActions.ADM_COMMANDE_SAVE_REQUEST(this.commande).then(()=> {         
        if(autoClose) this.$router.push({name:"Commande"})
    })
  }
  
  deleteCommande()  {    
    this.$confirm(`Voulez vous vraiment supprimer la commande "${this.commande.libelle}" ?`,{title: "Attention"} as VuetifyConfirmObject).then((answer) => {
      if (answer) {          
        this.$store.myActions.ADM_COMMANDE_DELETE_REQUEST(this.commande.id).then(()=>{
          this.$router.push({name:"Commande"})
        })          
      } 
    })   
  }


}
